<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addUser">Add User</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editUser">Edit User</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  @if (type === 'Edit') {
    <div class="img-container">
      <img (click)="editImage()" class="factory-image cursor" src="{{newImage ? newImage : user?.picturePath}}" onerror="this.src='../../../assets/images/avatar.png'" i18n-alt="@@userAvatarAlt">
      <mat-icon fontSet="material-icons-round" (click)="editImage()" color="accent" class="cursor edit-icon" aria-hidden="false" i18n-label="@@editImageIcon">edit</mat-icon>
    </div>
  }

  <form [formGroup]="addUserForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@firstNameLabel">First name</mat-label>
        <input data-testid="add_edit_user_first_name" matInput id="firstName" placeholder="First name" i18n-placeholder="@@firstNamePlaceholder" name="firstName" formControlName="firstName" required />
        <mat-error>
          @if (!addUserForm.get('firstName').valid && addUserForm.get('firstName').touched) {
            @if (addUserForm.get('firstName').errors && addUserForm.get('firstName').errors['required']  || addUserForm.get('firstName').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@lastNameLabel">Last name</mat-label>
        <input data-testid="add_edit_user_last_name" matInput id="lastName" placeholder="Last name" i18n-placeholder="@@lastNamePlaceholder" name="lastName" formControlName="lastName" required />
        <mat-error>
          @if (!addUserForm.get('lastName').valid && addUserForm.get('lastName').touched) {
            @if (addUserForm.get('lastName').errors && addUserForm.get('lastName').errors['required']  || addUserForm.get('lastName').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@emailLabel">Email</mat-label>
        <input data-testid="add_edit_user_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" required />
        <mat-error>
          @if (!addUserForm.get('email').valid && addUserForm.get('email').touched) {
            @if (addUserForm.get('email').errors && addUserForm.get('email').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (addUserForm.get('email').errors && !addUserForm.get('email').errors['required'] && addUserForm.get('email').errors['emailNotValid']) {
            <span i18n="@@inValidEmail">Please enter a valid email</span>
          }
        </mat-error>
      </mat-form-field>

      @if (type === 'Edit') {
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@passwordLabel">Password</mat-label>
          <input data-testid="add_edit_user_password" #password_edit [type]="hide ? 'password' : 'text'" matInput id="password_edit" i18n-placeholder="@@passwordPlaceholder" placeholder="Password" name="password_edit" formControlName="password_edit" />
          <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-label="@@togglePasswordVisibility">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
          <mat-hint align="end" [class]="meterMessage">{{meterMessage}}</mat-hint>
          <mat-error>
            @if (addUserForm.get('password_edit').errors && addUserForm.get('password_edit').errors['pattern']) {
              <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
            }
          </mat-error>
        </mat-form-field>
      }

      @if (type === 'Add') {
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@passwordLabel">Password</mat-label>
          <input data-testid="add_edit_user_password" #password_add [type]="hide ? 'password' : 'text'" matInput id="password_add" i18n-placeholder="@@passwordPlaceholder" placeholder="Password" name="password_add" formControlName="password_add" required />
          <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-label="@@togglePasswordVisibility">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
          <mat-hint align="end" [class]="meterMessage">{{meterMessage}}</mat-hint>
          <mat-error>
            @if (!addUserForm.get('password_add').valid && addUserForm.get('password_add').touched) {
              @if (addUserForm.get('password_add').errors['required']) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
            @if (addUserForm.get('password_add').errors && addUserForm.get('password_add').errors['pattern']) {
              <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
            }
          </mat-error>
        </mat-form-field>
      }
    </div>

    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_user_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_user_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>